import * as Toolkit from '../../../toolkit/index';
import * as CubeTree from '../../../cubeTree/index';
import { addLayerHeight } from './addLayerHeight';

function findTargetStageLayer(layers: CubePaintCoordinate[], mousePoint: MousePoint): CubeId|null {
    for(let i = 0; i < layers.length; i++) {
        if (CubeTree.isRoof(layers[i].id)) {
            continue;
        }
        let coordinate: CubePaintCoordinate = addLayerHeight(layers[i]);
        let point: MousePoint = {
            ...mousePoint
        };
        let rect: Rect = {
            left: coordinate.left,
            top: coordinate.top,
            width: coordinate.width,
            height: coordinate.height
        };

        if (Toolkit.pointInRect(point, rect)) {
            return coordinate.id;
        }
    }

    return null;
}

export {
    findTargetStageLayer
};
